const part = [
    {
        path: 'department-management-list',
        name: 'department-management-list',
        meta: {
            icon: 'md-people',
            title: '部门管理',
            notCache: true,
            access: ['S'],
            items: []
        },
        component: () => import('@/view/system-management/department-management/department-list')
    }
];

export default part;
